import { useSelector } from 'react-redux'
import isEqual from 'lodash/isEqual'

import { RootState } from 'types'

export const useWorkspaces = () => useSelector(({ workspace: { workspaces } }: RootState) => workspaces, isEqual)
